import { useCallback } from 'react';

import { TCommentType } from '@entities/comment/model/types';
import { useDeleteComment } from '@widgets/Comments/api/hooks';
import { getCommentsRequestErrorText } from '@widgets/Comments/lib/helpers/getCommentsRequestErrorText';

export const useHandleDelete = ({
    positionGuid,
    commentId,
    commentType,
    onSuccessCb,
    onErrorCb,
    defaultErrorText,
}: {
    positionGuid: string;
    commentId: string;
    commentType: TCommentType;
    onSuccessCb: () => void;
    onErrorCb?: (errorText: string) => void;
    defaultErrorText?: string;
}) => {
    const { mutateAsync: deleteCommentAsync } = useDeleteComment({
        onSuccess: onSuccessCb,
        onError: (error) => {
            const errorText = getCommentsRequestErrorText(error, defaultErrorText);

            if (errorText) {
                onErrorCb?.(errorText);
            }
        },
    });
    const handleDeleteComment = useCallback(async () => {
        try {
            await deleteCommentAsync({ commentId, commentType, positionGuid });
        } catch {
            console.error('delete error');
        }
    }, [commentId, commentType, positionGuid, deleteCommentAsync]);

    return {
        handleDeleteComment,
    };
};
